import { InboundEmail } from "@zickko/shared";
import { InboundEmailListItemWidget } from "./InboundEmailListItemWidget";

type Props = {
  emailList: InboundEmail[];
  onSelectEmail: (email) => void;
  filteredEmails: InboundEmail[];
};

export const InboundEmailListWidget = (props: Props) => {
  return (
    <div className="list-container">
      {props.filteredEmails.length === 0 ? (
        <div className="no-emails-message">No emails available.</div>
      ) : (
        props.filteredEmails.map((email) => (
          <InboundEmailListItemWidget email={email} key={email.id} onSelectEmail={() => props.onSelectEmail(email)} />
        ))
      )}
    </div>
  );
};
